import React, {useEffect, useState} from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Webcam from "react-webcam";
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import Typography from '@material-ui/core/Typography';
import Button from '@material-ui/core/Button';
import Slide from '@material-ui/core/Slide';
import Fab from '@material-ui/core/Fab';
import PhotoCamera from '@material-ui/icons/PhotoCamera';
// import credentials from './credentials.json'

const useStyles = makeStyles((theme) => ({
  root: {
    position: 'fixed',
  },
  instructions: {
    position: 'absolute',
    top: '30%',
    left: '50%',
    textAlign: 'center',
    fontFamily: '"Roboto", "Helvetica", "Arial", sans-serif',
    fontWeight: 'bold',
    fontSize: 24,
    transform: 'translate(-50%, -50%)',
    width: '100%',
    color: 'white',
  },
  image: {
    width: '100%',
  },
  dialog: {
    width: '100%',
  },
  thanks: {
    padding: 50,
  },
  button: {
    position: 'absolute',
    bottom: '10%',
    left: '50%',
    transform: 'translate(-50%, 0%)',
  },
  noDisplay: {
    display: "none"
  }
}));

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

export default function ImageUpload({token, onUpload}) {
  const classes = useStyles();

  const [image, setImage] = useState(null);
  const [uploaded, setUploaded] = useState(false);
  const [loading, setLoading] = useState(false);
  const [drivetoken, setToken] = useState();
  const [order, setOrder] = useState();
  const [count, setCount] = useState(1);
  const [license, setLicense] = useState(false);

  const client_secret = process.env.REACT_APP_CLIENT_SECRET
  const refresh_token = process.env.REACT_APP_REFRESH_TOKEN
  const client_id = process.env.REACT_APP_CLIENT_ID

  const size = useWindowSize();
  const isLandscape = size.height <= size.width;
  const ratio = isLandscape ? size.width / size.height : size.height / size.width;

  // Hook
    function useWindowSize() {
    // Initialize state with undefined width/height so server and client renders match
    // Learn more here: https://joshwcomeau.com/react/the-perils-of-rehydration/
    const [windowSize, setWindowSize] = useState({
      width: undefined,
      height: undefined,
    });

    useEffect(() => {
        // Handler to call on window resize
        function handleResize() {
          // Set window width/height to state
          setWindowSize({
            width: window.innerWidth,
            height: window.innerHeight,
          });
        }
        
        // Add event listener
        window.addEventListener("resize", handleResize);
        
        // Call handler right away so state gets updated with initial window size
        handleResize();
        
        // Remove event listener on cleanup
        return () => window.removeEventListener("resize", handleResize);
      }, []); // Empty array ensures that effect is only run on mount
    
      return windowSize;
    }

  useEffect(() => {
    if (window.location.pathname.split('/')[1] === 'license') {
        setLicense(true)
        setCount(0)
        setOrder(window.location.pathname.split('/')[2])
    } 
    else 
    {
        setOrder(window.location.pathname.split('/')[1])
    }
    fetch(`https://oauth2.googleapis.com/token?client_secret=${client_secret}&grant_type=refresh_token&refresh_token=${refresh_token}&client_id=${client_id}`, {
      method: 'POST',
      mode: 'cors',
      headers : { 
        'Content-Type': 'application/json',
        'Accept': 'application/json'
        }
  })
  .then(response => response.json())
  .then(json => {
      console.log("data",json)
      // setToken( _ => ({
      //   ...token, json
      // }))
      setToken(json)
  });
}, [client_secret, refresh_token, client_id]);

  const handleClose = () => {
    setImage(null);
  };

  function handleTakePhoto (image) {
    setImage(image);
    setLoading(false);
    // Do stuff with the photo...
    console.log('takePhoto');
  }

  function dataURLtoFile(dataurl, filename) {
 
    var arr = dataurl.split(','),
        mime = arr[0].match(/:(.*?);/)[1],
        bstr = atob(arr[1]), 
        n = bstr.length, 
        u8arr = new Uint8Array(n);
        
    while(n--){
        u8arr[n] = bstr.charCodeAt(n);
    }
    
    return new File([u8arr], filename, {type:mime});
}

  const handleUpload = () => {
    if (!image) {
      return;
    }

    count !== 0 ? setCount(count+1) : setCount(0)

    var metadata = {
        'name': `customerUploadOrder${order}${license ? "license" : ""}.webp`, // Filename at Google Drive
        'mimeType': 'image/webp', // mimeType at Google Drive
    };

    var docId = ""
    var form = new FormData();
    form.append('metadata', new Blob([JSON.stringify(metadata)], {type: 'application/json'}));
    var blobby = dataURLtoFile(image, `customerUploadOrder${order}.webp`);
    form.append('file', blobby);
    var xhr = new XMLHttpRequest();
    console.log("we here?")
    xhr.open('post', 'https://www.googleapis.com/upload/drive/v3/files?uploadType=multipart&fields=id');
    xhr.setRequestHeader('Authorization', `Bearer ${drivetoken.access_token}`);
    xhr.responseType = 'json';
    setLoading(true);
    xhr.onload = () => {
      setImage(null);
      setLoading(false);
      setUploaded(true);
      docId = `https://drive.google.com/file/d/${xhr.response.id}/view?usp=sharing`
      console.log(docId)
    }
    xhr.send(form);
  }

  let content = null;
  if (uploaded) {
    content = (
      <div className={classes.thanks}>
        <Typography align="center">
          Picture has been uploaded successully and is being processed.
          <br /><br /><br />
          <Button style={{width: '60%', marginLeft: '20%', display: count <= 6 && count !== 0 ? 'block' : 'none' }} variant="contained" color="primary" onClick={() => setUploaded(false)}>
          {count}/6 Take a Picture of the {
            count === 1 ? 'Front' : 
            count === 2 ? 'Driver Side' : 
            count === 3 ? 'Back' : 
            count === 4 ? 'Passenger Side' : 
            count === 5 ? 'Front Interior' : 
            'Rear Interior'
          } of the Car
          </Button>
          <Button style={{width: '60%', marginLeft: '20%', display: count > 6 || count === 0 ? 'block' : 'none' }} variant="contained" color="primary" onClick={() => setUploaded(false)}>
              Upload Any Other Pictures/Licenses You Wish To Document
          </Button>
        </Typography>
      </div>
    )
  } else {
    content = (
      <div className={classes.root}>
        <Webcam 
        height={size.height} 
        width={size.width}
        // aspectRatio={ratio}
        videoConstraints={license ? {facingMode: 'user', aspectRatio: ratio} : 
        {facingMode: 'environment', aspectRatio: ratio}}
        ref={camera => window.camera = camera} />
          <p style={{display: count <= 6 && count !== 0 ? 'block' : 'none' }} className={classes.instructions}>
            {count}/6 Take a Picture of the {
            count === 1 ? 'Front' : 
            count === 2 ? 'Driver Side' : 
            count === 3 ? 'Back' : 
            count === 4 ? 'Passenger Side' : 
            count === 5 ? 'Front Interior' : 
            'Rear Interior'
          } of the Car
          </p>
          <p style={{display: license ? 'block' : 'none' }} className={classes.instructions}>
              Please Take a Picture of Yourself Holding Your License
          </p>
          <p style={{display: count > 6 && count !== 0 ? 'block' : 'none' }} className={classes.instructions}>
              Take Any Other Pictures/Licenses You Wish To Document
          </p>
        <Fab color="primary"  className={classes.button} onClick={() => handleTakePhoto(window.camera.getScreenshot())}>
          <PhotoCamera style={{"width":"100vh"}} />
        </Fab>
      </div>
    );
  }

  return (
    <div>
      {content}
      <Dialog
        open={!!image}
        onClose={handleClose}
        aria-labelledby="form-dialog-title"
        TransitionComponent={Transition}
      >
        <DialogTitle id="form-dialog-title">Upload/Retake Photo</DialogTitle>
        <DialogContent>
          <DialogContentText>
            <img alt="camera" src={image} className={classes.image} />
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button disabled={loading} onClick={handleClose} color="primary">
            Retake
          </Button>
          <Button disabled={loading} onClick={handleUpload} color="primary" variant="contained">
            Upload
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
}
